export var getHostname = function () {
    var hostname = (typeof window !== 'undefined' || undefined) &&
        window.location &&
        window.location.hostname;
    if (!hostname || hostname.length === 0) {
        throw new Error('Hostname could not be determined for the current document.');
    }
    return hostname;
};
export var getPathname = function () {
    var pathname = (typeof window !== 'undefined' || undefined) &&
        window.location &&
        window.location.pathname;
    if (!pathname) {
        return '/';
    }
    return pathname;
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZG9tLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL2xpYi9kb20udHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsTUFBTSxDQUFDLElBQU0sV0FBVyxHQUFpQjtJQUN2QyxJQUFNLFFBQVEsR0FDWixDQUFDLE9BQU8sTUFBTSxLQUFLLFdBQVcsSUFBSSxTQUFTLENBQUM7UUFDNUMsTUFBTSxDQUFDLFFBQVE7UUFDZixNQUFNLENBQUMsUUFBUSxDQUFDLFFBQVEsQ0FBQztJQUUzQixJQUFJLENBQUMsUUFBUSxJQUFJLFFBQVEsQ0FBQyxNQUFNLEtBQUssQ0FBQyxFQUFFO1FBQ3RDLE1BQU0sSUFBSSxLQUFLLENBQ2IsNERBQTRELENBQzdELENBQUM7S0FDSDtJQUVELE9BQU8sUUFBUSxDQUFDO0FBQ2xCLENBQUMsQ0FBQztBQUVGLE1BQU0sQ0FBQyxJQUFNLFdBQVcsR0FBaUI7SUFDdkMsSUFBTSxRQUFRLEdBQ1osQ0FBQyxPQUFPLE1BQU0sS0FBSyxXQUFXLElBQUksU0FBUyxDQUFDO1FBQzVDLE1BQU0sQ0FBQyxRQUFRO1FBQ2YsTUFBTSxDQUFDLFFBQVEsQ0FBQyxRQUFRLENBQUM7SUFFM0IsSUFBSSxDQUFDLFFBQVEsRUFBRTtRQUNiLE9BQU8sR0FBRyxDQUFDO0tBQ1o7SUFFRCxPQUFPLFFBQVEsQ0FBQztBQUNsQixDQUFDLENBQUMifQ==